import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { Super_Admin, Admin } from "../../constant/AuthenticationConstant";
import { SET_PREVIOUS_PATH } from "../../redux/constants";

// Component
import OverviewDashboard from "./OverviewDashboard";
import MyOverviewTab from "./MyOverviewTab";

function OverviewIndex(props) {
  const [step, setStep] = useState(1);

  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
   dispatch({type: SET_PREVIOUS_PATH, payload: location.pathname.toString()})
  }, [])
  
  const user = useSelector((state) => state.auth);

  return (
    <div className="sm:mx-6 lg:mx-8">
      <div className={`sm:block sm:pt-1`}>
        <ul
          className="text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar border-b border-b-[#D9D9D9] space-x-12"
          id="tabs-tabJustify"
          role="tablist"
        >
          <li className="text-left">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                step === 1 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              id="My_Dashboard"
              onClick={() => setStep(1)}
            >
              To Do List
            </a>
          </li>
          {(user.type === Super_Admin || user.type === Admin) && (
            <li className="text-left">
              <a
                className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                  step === 2 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
                }`}
                id="Overall_Status"
                onClick={() => setStep(2)}
              >
                My Overview
              </a>
            </li>
          )}
        </ul>
      </div>

      {step === 1 && <OverviewDashboard {...props} />}
      {step === 2 && <MyOverviewTab />}
    </div>
  );
}

export default OverviewIndex;
